import { Outlet } from "react-router";

export function ProjectReviewVisitV2FunctionsRoute() {
    return <Outlet />;
}
